import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Etapa {
  _id;
  pem;
  fenologica;
  aplicacao;
  ordem;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.pem
   * @param {any} data.fenologica
   * @param {any} data.aplicacao
   * @param {any} data.ordem
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data, idToReplace) {
    Helpers.constructModel(data, this);
    this.idExtraData = idToReplace;
  }

  isNewEtapa() {
    return !this.idExtraData;
  }

  async prepare() {
    const curb = await db.etapas.filter(
      (x) =>
        (String(x.pem) === String(this.pem) ||
          String(x.pem_id) === String(this.pem)) &&
        String(x.ordem) === String(this.ordem),
    );
    let replaceId;
    // Checks if there is a existing step order to replace
    if (curb) {
      const arr = await curb.toArray();
      if (arr.length) {
        replaceId = arr[0]._id;
      }
    }
    // If there is already an entity with the data
    if (this.idExtraData) {
      const arr = await (
        await db.etapas.filter(
          (x) =>
            (String(x.pem) === String(this.pem) ||
              String(x.pem_id) === String(this.pem)) &&
            String(x._id) === String(this.idExtraData),
        )
      ).toArray();
      if (arr.length) {
        const etapa = { ...arr[0] };
        if (!etapa.produtos) {
          etapa.produtos = [];
        }
        if (etapa.produtos instanceof Object) {
          etapa.produtos = Object.values(etapa.produtos);
        }

        const incomingProdutos =
          this.produtos instanceof Array
            ? this.produtos
            : Object.values(this.produtos);

        this.produtos = [...incomingProdutos];
      }
    }

    this.updatedAt = moment().toDate().toISOString();
    this._id = replaceId || (await findEarliestAvailableID(db, 'etapas'));
    delete this.idExtraData;
    return this;
  }

  async save() {
    await this.prepare();
  }

  static describe = () =>
    '++_id, pem, fenologica, aplicacao, ordem, createdAt, updatedAt, deletedAt';
}
